module.exports = __webpack_public_path__ + "static/media/epic_wand.eec0159d.png";